
// ドロップダウンの位置が親にかぶらないように
// ドロップダウンの幅が親の幅に揃うように

import {merge} from 'lodash-es'
import {QDatetime} from 'quasar'

export default {
  ...QDatetime,

  render(h) {
    const createElement = (components, options, children) => {
      if(typeof components === 'object' && components.name === 'QPopover') {
        options = merge({}, options, {
          props: {
            cover: false,
            fit: true,
          },
        })
      }
      return h(components, options, children)
    }
    return QDatetime.render.bind(this)(createElement)
  },
}
